import { isUuid } from "@screencloud/uuid";
import { useState } from "react";
import { useAppContext } from "src/hooks/useAppContext";
import { File, useFileByIdQuery } from "src/types.g";
import {
  FileViewerSource,
  getFileViewerSource,
} from "../utils/getFileViewerSource";

export interface UseFileViewerFileResult {
  loading: boolean;
  title?: string;
  /** Undefined once loaded means the file is missing, forbidden or unviewable. */
  source?: FileViewerSource;
  /** Call when the media element fails to load its source. */
  onMediaError: () => void;
}

export const useFileViewerFile = (fileId: string): UseFileViewerFileResult => {
  const { secureMediaPolicy } = useAppContext();
  const validId = isUuid(fileId);
  const { data, loading } = useFileByIdQuery({
    variables: { id: fileId },
    skip: !validId,
  });
  const [mediaFailed, setMediaFailed] = useState(false);
  const file = data?.fileById;

  return {
    loading: validId && loading && !file,
    title: file?.name,
    source:
      file && !mediaFailed
        ? getFileViewerSource(file as Partial<File>, secureMediaPolicy)
        : undefined,
    onMediaError: () => setMediaFailed(true),
  };
};
